export enum ExcelMerchantListType {
  AdminExperience = 0,
  AffiliateExperience = 1,
}
